/**
 * @param {import('axios').AxiosInstance} axios
 */
export default function sessionTimeoutFactory(axios) {
  /**
   * If a request response has a status of 401 and the session has expired. Reload the page
   */
  return function sessionTimeout() {
    axios.interceptors.response.use(
      response => response,
      error => {
        if (
          error.response?.status === 401 &&
          error.response?.data?.data?.type === 'session-timeout'
        ) {
          // Reloading the page will cause the session to be refreshed by:
          // 1) hitting the signin page again OR
          // 2) hitting the session timeout page, if direct login is disabled asking the user to refresh the page in ehr
          globalThis.location.reload();
        }

        return Promise.reject(error);
      }
    );
  };
}
